function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  fill: "#053F5E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M159.855 581.775C106.072 418.38 194.931 242.323 358.327 188.54C486.192 146.453 621.812 191.717 700.52 291.696",
  stroke: "#115173",
  strokeWidth: 80,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M733.46 624.869C655.951 778.437 468.627 840.096 315.059 762.587C161.491 685.079 99.8329 497.755 177.341 344.187",
  stroke: "#115173",
  strokeWidth: 80,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M253.638 486.668C253.638 314.648 393.088 175.199 565.107 175.199C737.126 175.199 876.575 314.648 876.575 486.668",
  stroke: "white",
  strokeWidth: 80,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M790.814 548.844C781.237 538.898 781.536 523.072 791.482 513.495C801.428 503.918 817.254 504.217 826.831 514.163L790.814 548.844ZM927.659 516.068C937.605 506.491 953.431 506.79 963.008 516.736C972.585 526.682 972.286 542.508 962.34 552.085L927.659 516.068ZM826.831 514.163L886.697 576.335L850.68 611.016L790.814 548.844L826.831 514.163ZM865.488 575.934L927.659 516.068L962.34 552.085L900.169 611.951L865.488 575.934ZM886.697 576.335C880.951 570.367 871.455 570.188 865.488 575.934L900.169 611.951C886.245 625.358 864.088 624.94 850.68 611.016L886.697 576.335Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M785.014 706.941C663.378 828.577 466.167 828.577 344.531 706.941C222.895 585.305 222.895 388.094 344.531 266.458",
  stroke: "white",
  strokeWidth: 80,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M477.989 400.663H516.389V483.763H612.389V400.663H650.789V610.663H612.389V519.763H516.389V610.663H477.989V400.663Z",
  fill: "white"
});

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.b8fbea68.svg";
export { ForwardRef as ReactComponent };